import { Bell, User, Settings, LogOut } from "lucide-react";
//import logo from "../assets/logo.png"; //  adjust path
import { useEffect, useState } from "react";
import Logo from "../components/common/Logo";


const FrameComponent = () => {

  const [user, setUser] = useState(null);
//==================== Login Profile  Details==============
 useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        console.log("Stored User:", parsedUser);
        setUser(parsedUser);
    }
}, []);

  //================Logout Handle ===============
  const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  window.location.href = "/";
};

  return (
    <div className="bg-secondary rounded-xl shadow-card p-4 flex flex-col md:flex-row items-center justify-between">

      {/* LEFT: Logo */}
      <div className="flex items-center gap-3 w-full md:w-auto justify-between md:justify-start">

        {/* LEFT: Logo */}
        <div className="flex items-center gap-3 w-full md:w-auto justify-between md:justify-start">

          {/* Wrap logo + text in column */}
          <div className="flex flex-col">

            {/* Logo */}
            {/* <div className="bg-[#1e1e1e] rounded-xl px-6 py-3 flex items-center w-fit">
              <span className="text-white text-2xl md:text-3xl font-['Great_Vibes']">
                Insta
              </span>
              <span className="text-white text-4xl md:text-5xl font-black ml-1">
                ED
              </span>
            </div> */}

            {/* Paragraph BELOW logo */}
            {/* <p className="text-sm md:text-base text-gray-600 mt-1">
              Online Tuitions | 6-12
            </p> */}
            <Logo/>

          </div>

        </div>

        {/* Mobile Icons (optional) */}
        <div className="flex md:hidden gap-3 text-primary">
          <Bell className="icon" />
          <User className="icon" />
        </div>
      </div>

     <div className="flex items-start gap-6">
       {/* CENTER: Profile */}
      <div className="flex justify-end gap-3">
        <img
          className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
          src="/g1.jpg"
          alt="Profile"
        />

        <div className="text-xs md:text-sm">
          <p className="font-semibold">
            Hi, {user?.userID ? user.userID.split("@")[0] : "User"}
          </p>

          <p className="text-gray-500 hidden sm:block">
            Sudent ID: {user?.uuid || "-"}
          </p>

          <p className="text-gray-500 hidden sm:block">
            Batch: {user?.sessionId || "-"}
          </p>

          <p className="text-gray-500 hidden sm:block">
            Role: {user?.role || "-"}
          </p>

          <p>
            <span className="text-gray-500 font-medium">
              Subscription: {user?.subscription || "N/A"}</span>
          </p>
        </div>
      </div>

      {/* RIGHT: Icons */}
      <div className="hidden md:flex gap-4 text-primary">
        <Bell className="icon" />
        <User className="icon" />
        <Settings className="icon" />
        <LogOut className="icon cursor-pointer" onClick={handleLogout} />
      </div>
     </div>
    </div>
  );
};

export default FrameComponent;